import React from 'react';
import Icon from './Icon';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

const ToolTipIcon = ({ toolTipText }) => (
  <Icon tooltip={toolTipText} iconObj={faInfoCircle} />
);

export default ToolTipIcon;